import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

import Icon from 'widgets/Icon/Icon';

import { getOfferLink } from 'apps/catalogue/links';
import wa from 'apps/analytics/services/waEventEmitter';
import { pageEvents, pageEventFields } from 'apps/products/analytics';

export function Offer(props) {
  const { text, edlpDescription, isClickable } = props;
  const offerLink = getOfferLink(props);
  const offerData = [
    <Icon key="offer-icon" name="offer" />,
    <p key="offer-title" className="bop-promotion__title bop-promotion__title--offer">
      {text}
    </p>,
    <p key="offer-description" className="bop-promotion__description">
      {edlpDescription}
    </p>,
  ];

  if (!isClickable) {
    return (
      <div className="bop-promotion">
        <div className="bop-promotion__text">
          {offerData}
        </div>
        <div className="gn-divider gn-divider--light bop-promotion__divider" />
      </div>
    );
  }

  return (
    <div className="bop-promotion">
      <Link
        onClick={() => wa.triggerPageEventWithDescription(pageEvents.BOP_PROMOTION_CLICKED,
          { [pageEventFields.PROMO_ID]: props.id })}
        className="bop-promotion__link"
        to={offerLink}
      >
        {offerData}
        <Icon name="chevron-right" className="icon__action" />
      </Link>
      <div className="gn-divider gn-divider--light bop-promotion__divider" />
    </div>
  );
}

Offer.propTypes = {
  description: PropTypes.string,
  id: PropTypes.string,
  isClickable: PropTypes.bool,
  text: PropTypes.string,
};

